.userMenu {
  overflow: hidden;

  button {
    padding: 7px 8px;
    margin-bottom: 2px;

    svg {
      width: 17px;
      height: 17px;
      margin-right: 6px;
    }

    span {
      text-transform: none;
      font-family: var(--font-family__heading);
      font-size: 14px;
      font-weight: normal;
      color: #00223c;

      padding-right: 36px;
    }

    .arrowDropDown {
      color: #595959;
      font-size: 36px;
      position: absolute;
      right: 0;
    }
  }
}
